import { animate, state, style, transition, trigger } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
import { Component, NgZone, OnDestroy, OnInit, AfterViewInit, ElementRef, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { SelectOccupancy } from '../Models/select-occupancy';
import { OccupancyService } from '../ApiServices/occupancy.service';
import { MasterRolePermission } from '../Models/master-role-permission';

import * as $ from 'jquery';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-occupancy',
  templateUrl: './occupancy.component.html',
  styleUrls: ['./occupancy.component.css']
})
export class OccupancyComponent implements OnInit, OnDestroy {

  selectOccupancy: SelectOccupancy;

  constructor(@Inject(DOCUMENT) private document, private elementRef: ElementRef, private router: Router, private occupancyService: OccupancyService) { }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    var token = sessionStorage.getItem('token');
    if (token == null) {
      this.router.navigateByUrl('/');
      return;
    } else {
      if (sessionStorage.getItem("ROLE_PERMISSIONS").toString().indexOf(MasterRolePermission.ViewOccupancy.rolePermission) < 0) {
        alert("Unauthorised access");
        this.router.navigateByUrl('/index');
        return;
      } else {
        $(document).ready(function () {
          //alert('Jquery');
        });

        this.Populate();
      }
    }
  }

  ngAfterViewInit() {
  }
  afterScriptAdded() {
  }

  Populate() {
    this.occupancyService.SelectOccupancy(new SelectOccupancy()).subscribe((masterOccupancyResp) => {

      this.selectOccupancy = masterOccupancyResp;

      var TOTAL = this.selectOccupancy.AVAILABLE + this.selectOccupancy.OCCUPIED;

      var xValues = ["Available " + Math.round(this.percentage(this.selectOccupancy.AVAILABLE, TOTAL)) + "%", "Occipied " + Math.round(this.percentage(this.selectOccupancy.OCCUPIED, TOTAL)) + "%"];
      var yValues = [
        this.selectOccupancy.AVAILABLE,
        this.selectOccupancy.OCCUPIED
      ];

      
      var barColors = [
        "green",
        "red"
      ];

      new Chart("chartTotalParkingCapacity", {
        type: "pie",
        data: {
          labels: xValues,
          datasets: [{
            backgroundColor: barColors,
            data: yValues
          }]
        },
        options: {
          title: {
            display: true,
            text: "Total Parking Capacity"
          }
        }
      });

      $('#totalCapacitySpan').html(TOTAL);
      $('#availableCapacitySpan').html(this.selectOccupancy.AVAILABLE);
      $('#occupiedCapacitySpan').html(this.selectOccupancy.OCCUPIED);
    }, (err) => {
    });

  }

  percentage(partialValue, totalValue) {
    return (100 * partialValue) / totalValue;
  }
}
